import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { classicMigrationFilespaceSummarySchema } from '#web-service-api/filespace-migration';
export const PartnerOrganizationMigrationConfigResponseSchema = z.object({
    id: z.number(),
    partnerOrganizationId: z.string(),
    classicDomainId: z.string(),
    classicDomainName: z.string(),
    // The classic filespace ids explicitly associated with an MSP client organization (id-only).
    classicFilespaceIds: z.array(z.string()).optional(),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    canDelete: z.boolean().default(false),
    // Full classic filespace summaries, populated only when explicitly requested.
    filespaces: z.array(classicMigrationFilespaceSummarySchema).optional(),
});
export class PartnerOrganizationMigrationConfigResponseDto extends createZodDto(PartnerOrganizationMigrationConfigResponseSchema) {
}
